export default "__VITE_ASSET__DU80URn0__"